export default __webpack_public_path__ + "static/media/Profile.5f3e8abb.PNG";